export const registrationTranslations = {
  lv: {
    registerOrganization: 'Reģistrēt organizāciju',
    title: 'Reģistrācija praktikantu piesaistei uzņēmumā',
    firstName: 'Vārds',
    lastName: 'Uzvārds',
    firstNameRequired: 'Ievadiet vārdu',
    lastNameRequired: 'Ievadiet uzvārdu',
    phone: 'Tālrunis',
    phoneDescription: 'Tālruņa numurs autorizācijas SMS saņemšanai.',
    countryCode: 'Valsts tālruņa kods',
    countryCodeInvalid: 'Ievadiet derīgu valsts kodu',
    phoneInvalid: 'Ievadiet tālruņa numuru, izmantojot tikai ciparus',
    sendSms: 'Sūtīt SMS',
    resendSms: 'Sūtīt SMS vēlreiz',
    securityCode: 'Drošības kods',
    securityCodeInvalid: 'Ievadiet drošības kodu, izmantojot tikai ciparus',
    requestSms: 'Vispirms pieprasiet SMS kodu.',
    agreeToTerms: 'Piekrītu',
    terms: 'lietošanas noteikumiem',
    termsRequired: 'Lai reģistrētos, jāpiekrīt lietošanas noteikumiem',
    agreeToDataPolicy: 'Piekrītu personas datu apstrādes noteikumiem',
    dataPolicyRequired: 'Lai reģistrētos, jāpiekrīt personas datu apstrādes noteikumiem',
    register: 'Reģistrēties',
    smsSent: 'Drošības kods nosūtīts SMS. Tas ir derīgs 10 minūtes.',
    smsError: 'Neizdevās nosūtīt SMS. Mēģiniet vēlreiz.',
    registerErrorTitle: 'Reģistrācija neizdevās',
    registerError: 'Neizdevās reģistrēties. Mēģiniet vēlreiz.',
  },
  en: {
    registerOrganization: 'Register organization',
    title: 'Registration to get interns for your company',
    firstName: 'First name',
    lastName: 'Last name',
    firstNameRequired: 'Enter your first name',
    lastNameRequired: 'Enter your last name',
    phone: 'Phone',
    phoneDescription: 'Phone number for authorization SMS.',
    countryCode: 'Country calling code',
    countryCodeInvalid: 'Enter a valid country calling code',
    phoneInvalid: 'Enter a phone number using only digits',
    sendSms: 'Send SMS',
    resendSms: 'Resend SMS',
    securityCode: 'Security code',
    securityCodeInvalid: 'Enter a security code using only digits',
    requestSms: 'Request an SMS code first.',
    agreeToTerms: 'I agree to the',
    terms: 'terms of use',
    termsRequired: 'Agree to the terms of use to register',
    agreeToDataPolicy: 'I agree to the personal data processing terms',
    dataPolicyRequired: 'Agree to the personal data processing terms to register',
    register: 'Register',
    smsSent: 'The security code was sent by SMS. It is valid for 10 minutes.',
    smsError: 'The SMS could not be sent. Please try again.',
    registerErrorTitle: 'Registration failed',
    registerError: 'Registration failed. Please try again.',
  },
} as const
